import React from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

const HeroSectionWebinarBan = () => {
  const sliderData = [
    
    {
      id: 1,
      title: "",
      img: "assets/images/event-banner/Website-meetup-banner-26.png",
      description: "",
      img2: "assets/images/event-banner/Website-meetup-tesxt-2-26.png",
      buttonLabel: "",
      buttonLink: "",
      buttonLabel2: "Register Now",
      buttonLink2: "/members-meet-2026#rsvp-form",
    },
    {
      id: 2,
      title: "",
      img: "assets/images/event-banner/Webnair-02-march.png",
      description: "",
      img2: "assets/images/event-banner/webinar-yt-subtext.png",
      buttonLabel: "",
      buttonLink: "",
      buttonLabel2: "Watch Webinar",
      buttonLink2: "https://youtu.be/WCF_Uyq2KOs?si=qA2RmR-7FqUzKIE0",
    },
  ];

  return (
    <section className="container-fluid banner-custome-padding">
      <div
        className="hero_section hero_financial_consulting parallaxie position-relative"
        style={{ padding: "40px 0px" }}
      >
        <div className="row g-4 align-items-stretch justify-content-center px-lg-5">
          {sliderData.map((item) => (
            <div key={item.id} className="col-lg-6 col-md-12 d-flex">
              <div
                className="d-flex flex-column align-items-center justify-content-center p-4 p-md-5 w-100"
                style={{
                  backgroundColor: "#f4f4f4",
                  borderRadius: "20px",
                }}
              >
                {item.title && (
                  <motion.h1
                    className="hero_title text-dark mb-3 text-center"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    {item.title.split(" ").map((word, i) =>
                      ["Stronger", "Not-for-Profit", "Association", "₤1"].includes(
                        word
                      ) ? (
                        <motion.mark
                          key={i}
                          initial={{ opacity: 0, y: -20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{
                            delay: i * 0.2,
                            duration: 0.5,
                            ease: "easeInOut",
                          }}
                          style={{
                            display: "inline-block",
                            background: "#fff",
                            borderRadius: "10px",
                            marginLeft: "10px",
                          }}
                        >
                          {word}
                        </motion.mark>
                      ) : (
                        <span key={i}> {word}</span>
                      )
                    )}
                  </motion.h1>
                )}

                {item.img && (
                  <img
                    className="msbimgcss img-fluid "
                    src={item.img}
                    alt=""
                    style={{
                      display: "block",
                      margin: "0 auto"
                    }}
                  />
                )}

                {item.description && (
                  <motion.p
                    className="text-center mb-3"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    {item.description}
                  </motion.p>
                )}

                {item.img2 && (
                  <img
                    src={item.img2}
                    alt=""
                    className="img-fluid mb-4"
                    style={{
                      display: "block",
                      margin: "0 auto"
                    }}
                  />
                )}

                {/* Buttons */}
                <div className={item.id === 2 ? "d-flex gap-3 flex-wrap mt-3 ps-lg-5 sm-justify" : "d-flex gap-3 flex-wrap justify-content-center mt-auto"}>
                  {item.buttonLabel && (
                    <NavLink
                      className="btn bg-primary rounded-pill"
                      to={item.buttonLink}
                    >
                      <span className="btn_label" style={{ color: "#333" }}>
                        {item.buttonLabel}
                      </span>
                      <span className="btn_icon">
                        <svg
                          width={20}
                          height={16}
                          viewBox="0 0 20 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289L13.3431 0.928932C12.9526 0.538408 12.3195 0.538408 11.9289 0.928932C11.5384 1.31946 11.5384 1.95262 11.9289 2.34315L17.5858 8L11.9289 13.6569C11.5384 14.0474 11.5384 14.6805 11.9289 15.0711C12.3195 15.4616 12.9526 15.4616 13.3431 15.0711L19.7071 8.70711ZM0 9H19V7H0V9Z"
                            fill="#333"
                          />
                        </svg>
                      </span>
                    </NavLink>
                  )}

                  {item.id === 2 && item.buttonLabel2 ? (
                    <a
                      href={item.buttonLink2}
                      className="d-inline-flex align-items-center justify-content-center gap-2 px-5 py-2 rounded-pill btn3"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        background: "#fff",
                        textDecoration: "none",
                        color: "#333",
                        fontWeight: 600,
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        minWidth: "220px",
                        height: "48px"
                      }}
                    >
                      <span
                        style={{
                          background: "#FF0000",
                          borderRadius: "25%",
                          width: "35px",
                          height: "28px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="#fff"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10 16.5L16 12L10 7.5V16.5Z" />
                        </svg>
                      </span>
                      {item.buttonLabel2}
                    </a>
                  ) : item.buttonLabel2 ? (
                    <NavLink
                      to={item.buttonLink2}
                      className="d-inline-flex align-items-center justify-content-center gap-2 px-5 py-2 rounded-pill btn3"
                      rel="noopener noreferrer"
                      style={{
                        background: "#fff",
                        textDecoration: "none",
                        color: "#333",
                        fontWeight: 600,
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        minWidth: "220px",
                        height: "48px"
                      }}
                    >
                      {item.buttonLabel2}
                    </NavLink>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSectionWebinarBan;
